import * as React from 'react'

import { ApprovalMaterializedApprovalFragment } from 'generated/resources/graphql'

import type { RequestComponentProps } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/base'

import BasePendingApproval from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals'
import { ApprovalData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals/types'

export interface CollapseContentData extends ApprovalData {
  resourceId: string
}

const PurchaseApprovals = ({
  request,
  index,
  compact,
  removeRequestById,
}: RequestComponentProps) => {
  const fetchResources = async (flow: ApprovalMaterializedApprovalFragment) => ({
    resourceId: flow.resourceId,
  })

  return (
    <BasePendingApproval
      request={request}
      index={index}
      compact={compact}
      getApprovalData={(flow) => fetchResources(flow)}
      removeRequestById={removeRequestById}
    />
  )
}

export default PurchaseApprovals
